import React, {Component} from 'react';
import { Row, Col, FormControl } from 'react-bootstrap';
import { Checkbox, Radio } from 'react-icheck';
import PrintPreview from './PrintPreview';
import PdfStore from '../../stores/PdfStore';

class PrintCheckingDamageDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false, data:[]}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('landscape');
  }

  componentDidMount(){
    
  }
  

  renderLogoUrl(logoUrl){
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    return (<img src={imgUrl} />)
  }

  renderComponentPage() {
    return(
      <div className='font-print'>
        <header>
          <h2 className="text-right"></h2>
        </header>
        <div className=''>   
          <Row>
            <Col md={6} style={{float:'left', padding:'0 0 0 20px'}}>
              <table className='table table-check-damage-doc table-bordered'>
                <tbody>
                  <tr>
                    <td colSpan={3} className='text-center font-40 tb-col-left'>
                      TOYOTA/VIOS
                      <br/>
                      ฌน 9890 (042)
                    </td>
                  </tr>
                  <tr>
                    <td><u>รายการ</u></td>
                    <td className='hr-l-none'></td>
                  </tr>
                  <tr>
                    <td className='t-order hr-t-none font-24' colSpan={3}>1 <span className='font-18'>ฝากระโปรงหน้า</span></td>
                  </tr>
                  <tr>
                    <td className='t-order hr-t-none font-24' colSpan={3}>2 <span className='font-18'>ประตูหน้าซ้าย</span></td>
                  </tr>
                  <tr>
                    <td className='t-order hr-t-none font-24' colSpan={3}>3 <span className='font-18'>0</span></td>
                  </tr>
                  <tr>
                    <td className='t-order hr-t-none font-24' colSpan={3}>4 <span className='font-18'>0</span></td>
                  </tr>
                  <tr>
                    <td className='t-order hr-t-none font-24' colSpan={3}>5 <span className='font-18'>0</span></td>
                  </tr>
                  <tr>
                    <td className='t-order hr-t-none font-24' colSpan={3}>6 <span className='font-18'>0</span></td>
                  </tr>
                  <tr>
                    <td className='t-order hr-t-none font-24' colSpan={3}>7 <span className='font-18'>0</span></td>
                  </tr>
                  <tr>
                    <td className='t-order hr-t-none font-24' colSpan={3}>8 <span className='font-18'>0</span></td>
                  </tr>
                  <tr>
                    <td className='t-order hr-t-none font-24' colSpan={3}>9 <span className='font-18'>0</span></td>
                  </tr>
                  <tr>
                    <td className='t-order hr-t-none font-24' colSpan={3}>10 <span className='font-18'>0</span></td>
                  </tr>
                  <tr>
                    <td colSpan={3} className='t-order text-center hr-t-none'>________</td>
                  </tr>
                  <tr>
                    <td className='hr-t-none'><u>อะไหล่</u></td>
                    <td className='hr-t-none hr-l-none'></td>
                  </tr>
                  <tr>
                    <td className='t-order hr-t-none font-24' colSpan={3}>1 <span className='font-18'>ฝากระโปรงหน้า</span></td>
                  </tr>
                  <tr>
                    <td className='t-order hr-t-none font-24' colSpan={3}>2 <span className='font-18'>ประตูหน้าซ้าย</span></td>
                  </tr>
                  <tr>
                    <td className='t-order hr-t-none font-24' colSpan={3}>3 <span className='font-18'>0</span></td>
                  </tr>
                  <tr>
                    <td className='t-order hr-t-none font-24' colSpan={3}>4 <span className='font-18'>0</span></td>
                  </tr>
                  <tr>
                    <td className='t-order hr-t-none font-24' colSpan={3}>5 <span className='font-18'>0</span></td>
                  </tr>
                  <tr>
                    <td className='t-order hr-t-none font-24' colSpan={3}>6 <span className='font-18'>0</span></td>
                  </tr>
                  <tr>
                    <td className='t-order hr-t-none font-24' colSpan={3}>7 <span className='font-18'>0</span></td>
                  </tr>
                </tbody>
              </table>
            </Col>
            <Col md={6} style={{float:'right', padding:'0 20px 0 0'}}>
              <table className='table table-check-damage-doc table-bordered'>
                <tbody>
                  <tr>
                    <td className='hr-l-none hr-t-none tb-col-right' style={{padding:'0'}}></td>
                    <td className='hr-l-none hr-t-none hr-r-none' style={{padding:'0'}}>
                      วันที่เริ่มทำ____________________เวลา____________________
                    </td>
                  </tr>
                  <tr>
                    <td className='hr-l-none hr-t-none'></td>
                    <td className='p-b-22 hr-l-none hr-t-none hr-r-none' style={{paddingLeft:'0', paddingTop:'26px'}}>
                      วันที่ทำเสร็จ____________________เวลา____________________
                    </td>
                  </tr>
                  <tr>
                    <td className='text-center hr-l-none'>วันที่</td>
                    <td className='text-center'>รายการ</td>
                    <td className='text-center'>จำนวน</td>
                  </tr>
                  <tr>
                    <td className='text-center hr-l-none'><br/></td>
                    <td className='text-center'></td>
                    <td className='text-center'></td>
                  </tr>
                  <tr>
                    <td rowSpan={2} className='text-center hr-l-none font-40'>บริษัท</td>
                    <td rowSpan={2} className='text-center font-40'>ธนชาต</td>
                    <td className='text-center'></td>
                  </tr>
                  <tr>
                    <td className='text-center'></td>
                  </tr>
                  <tr>
                    <td className='text-center hr-l-none'><br/></td>
                    <td className='text-center'></td>
                    <td className='text-center'></td>
                  </tr>
                  <tr>
                    <td rowSpan={2} className='text-center hr-l-none font-40'>รถเข้า</td>
                    <td rowSpan={2} className='text-center font-40'>8/1/2561</td>
                    <td className='text-center'></td>
                  </tr>
                  <tr>
                    <td className='text-center'></td>
                  </tr>
                  <tr>
                    <td className='text-center hr-l-none'><br/></td>
                    <td className='text-center'></td>
                    <td className='text-center'></td>
                  </tr>
                  <tr>
                    <td rowSpan={2} className='text-center hr-l-none font-40'>รถออก</td>
                    <td rowSpan={2} className='text-center font-40'></td>
                    <td className='text-center'></td>
                  </tr>
                  <tr>
                    <td className='text-center'></td>
                  </tr>
                  <tr>
                    <td className='text-center hr-l-none'><br/></td>
                    <td className='text-center'></td>
                    <td className='text-center'></td>
                  </tr>
                  <tr>
                    <td className='text-center hr-l-none'><br/></td>
                    <td className='text-center'></td>
                    <td className='text-center'></td>
                  </tr>
                  <tr>
                    <td rowSpan={2} className='text-center hr-l-none font-40'></td>
                    <td rowSpan={2} className='text-center font-40'></td>
                    <td className='text-center'></td>
                  </tr>
                  <tr>
                    <td className='text-center'></td>
                  </tr>
                  <tr>
                    <td className='text-center hr-l-none'><br/></td>
                    <td className='text-center'></td>
                    <td className='text-center'></td>
                  </tr>
                  <tr>
                    <td className='text-center hr-l-none'><br/></td>
                    <td className='text-center'></td>
                    <td className='text-center'></td>
                  </tr>
                  <tr>
                    <td className='text-center hr-l-none'><br/></td>
                    <td className='text-center'></td>
                    <td className='text-center'></td>
                  </tr>
                  <tr>
                    <td className='text-center hr-l-none'><br/></td>
                    <td className='text-center'></td>
                    <td className='text-center'></td>
                  </tr>
                  <tr>
                    <td className='text-center hr-l-none'><br/></td>
                    <td className='text-center'></td>
                    <td className='text-center'></td>
                  </tr>
                  <tr>
                    <td className='text-center hr-l-none'><br/></td>
                    <td className='text-center'></td>
                    <td className='text-center'></td>
                  </tr>
                  <tr>
                    <td className='text-center hr-l-none'><br/></td>
                    <td className='text-center'></td>
                    <td className='text-center'></td>
                  </tr>
                  <tr>
                    <td className='text-center hr-l-none'><br/></td>
                    <td className='text-center'></td>
                    <td className='text-center'></td>
                  </tr>
                  <tr>
                    <td className='text-center hr-l-none'><br/></td>
                    <td className='text-center'></td>
                    <td className='text-center'></td>
                  </tr>
                  <tr>
                    <td className='text-center hr-l-none'><br/></td>
                    <td className='text-center'></td>
                    <td className='text-center'></td>
                  </tr>
                </tbody>
              </table>
            </Col>            
          </Row>                  
        </div>
      </div>  
    )
  }

  render() {
    let {loading} = this.state
    return(
      <PrintPreview 
        loading={loading} 
        size={'landscape'}
        leftBarTitle={'ใบตรวจสอบความเสียหาย '+this.props.workNo}>
        {this.renderComponentPage()}
      </PrintPreview>
    )
  }

}  

PrintCheckingDamageDoc.defaultProps = {
  title: 'ใบตรวจสอบความเสียหาย',  
  mode : '1'
}
export default PrintCheckingDamageDoc;


// WEBPACK FOOTER //
// ./src/view/print/PrintCheckingDamageDoc.js